/** Which assistant owns the lower-right FAB. Header help always opens the Navigator. */
export type CornerAssistant = 'guides' | 'co_facilitator';

/** Per-user UI prefs for the workspace help panel. */

export interface HarryUiPrefs {
  /** When false, hide the Navigator FAB when it owns the corner (header icon still opens the panel). */
  showFloatingLauncher: boolean;
  /** Exclusive corner FAB: the Navigator (product help) or Co-Facilitator (methodology coach). */
  cornerAssistant: CornerAssistant;
}

const DEFAULT_PREFS: HarryUiPrefs = {
  showFloatingLauncher: true,
  cornerAssistant: 'guides',
};

function storageKey(userId: string | null | undefined): string {
  return `pp_harry_ui_${userId || 'anon'}`;
}

function normalizePrefs(parsed: Partial<HarryUiPrefs>): HarryUiPrefs {
  const corner =
    parsed.cornerAssistant === 'co_facilitator' || parsed.cornerAssistant === 'guides'
      ? parsed.cornerAssistant
      : DEFAULT_PREFS.cornerAssistant;
  return {
    showFloatingLauncher: parsed.showFloatingLauncher ?? DEFAULT_PREFS.showFloatingLauncher,
    cornerAssistant: corner,
  };
}

export function loadHarryUiPrefs(userId: string | null | undefined): HarryUiPrefs {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return DEFAULT_PREFS;
    const parsed = JSON.parse(raw) as Partial<HarryUiPrefs>;
    return normalizePrefs(parsed);
  } catch {
    return DEFAULT_PREFS;
  }
}

export function saveHarryUiPrefs(userId: string | null | undefined, prefs: Partial<HarryUiPrefs>): HarryUiPrefs {
  const next = normalizePrefs({ ...loadHarryUiPrefs(userId), ...prefs });
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(next));
  } catch { /* ignore */ }
  return next;
}
